export default "__VITE_ASSET__77583fae__"